import { extendADNDDropTarget } from './ADNDDropTarget'
// import { DATA_ITEM_TYPE_PREFIX } from '../ADNDHelpers'
import { JSON_TYPE } from '../sources/ADNDDataSource'

const PRIVATE = {
  fetchData(state, event) {
    if (null != state.source) {
      const data = {
        type: state.source.PUBLIC.getType(),
        data: state.source.PUBLIC.getData(),
        clone: 'clone' == state.operation.type
      }
      return [data]
    } else if (event.dataTransfer && state.item.type) {
      try {
        // event.dataTransfer.setData(`${DATA_ITEM_TYPE_PREFIX}${this.props.acceptTypes[0]}`, 'true')
        const eventData = JSON.parse(event.dataTransfer.getData(JSON_TYPE))
        const data = {
          type: state.item.type,
          data: eventData,
          clone: true
        }
        return [data]
      } catch {
        //
      }
    }
    return null
  }
}

const PUBLIC = {
  clone({ acceptTypes = this.props.acceptTypes, dynamicPosition = this.props.dynamicPosition } = {}) {
    return ADNDDropDataTarget({ acceptTypes, dynamicPosition })
  }
}

export default function ADNDDropDataTarget({ acceptTypes, dynamicPosition = false } = {}) {
  const ADNDDropDataTarget = extendADNDDropTarget({ acceptTypes, dynamicPosition })

  ADNDDropDataTarget.PRIVATE.fetchData = PRIVATE.fetchData.bind(ADNDDropDataTarget)

  ADNDDropDataTarget.PUBLIC.clone = PUBLIC.clone.bind(ADNDDropDataTarget)

  return ADNDDropDataTarget.PUBLIC
}
